import { defBaseUnit, defSimpleUnit } from '../registry';

export const calendarUnits = [
  defBaseUnit('month'),
  defSimpleUnit('quarter', 'month', 3),
  defSimpleUnit('year', 'month', 12),
  defSimpleUnit('decade', 'month', 120),
];
